import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_PROJECT_LIST, GET_PROJECT_LIST_SUCCESS, GET_PROJECT_LIST_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getProjectList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const params = new URLSearchParams();
    payload?.data.forEach(id => params.append('airportId', id));
    console.log('params', params);

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/configurations/benefit-type/airport-transfer/projects?${params?.toString()}`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROJECT_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: GET_PROJECT_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROJECT_LIST_ERROR, payload: error });
  }
}

export function* watchgetProjectList() {
  yield takeEvery(GET_PROJECT_LIST, getProjectList);
}

function* getProjectListSaga() {
  yield all([fork(watchgetProjectList)]);
}

export default getProjectListSaga;
